import { render, staticRenderFns } from "./TableWorkDescription.vue?vue&type=template&id=7d54b77a"
import script from "./TableWorkDescription.vue?vue&type=script&lang=ts"
export * from "./TableWorkDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports